import { render, staticRenderFns } from "./WhatsappGroupsList.vue?vue&type=template&id=25df2b00"
import script from "./WhatsappGroupsList.vue?vue&type=script&lang=js"
export * from "./WhatsappGroupsList.vue?vue&type=script&lang=js"
import style0 from "./WhatsappGroupsList.vue?vue&type=style&index=0&id=25df2b00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports